import type { MouseEventHandler } from 'react';

export function useScrollIntoView(
  target: string,
  scrollTopMargin?: string,
): MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> {
  const handleClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = e => {
    if (typeof document === 'undefined') return () => undefined;
    const targetElement = document.getElementById(target);
    e.preventDefault();
    if (targetElement) {
      if (scrollTopMargin) {
        targetElement.style.scrollMarginTop = scrollTopMargin;
      }
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  };
  return handleClick;
}
